import { STAGES, REVIEW_STAGES, stageDef } from '@/lib/stages'
import type { Role } from '@/lib/types'

/** Stage label as a coloured chip. Numbers shown to people are 1-based (`num`). */
export function StageChip({ stage, withNum = false, version = 2 }: { stage: number; withNum?: boolean; version?: number }) {
  const d = stageDef(stage, version)
  return <span className={`chip s${d.stage}${stage === 1 && version === 2 ? ' peer-review' : ''}`} title={`Stage ${d.num} of ${STAGES.length}`}>{withNum && <span>{d.num}</span>}{d.label}</span>
}

/** Horizontal stepper of all six stages with the current one highlighted. Devs see themselves as "dev", experts see "engineer". */
export function StageStepper({ stage, viewer = 'sme' }: { stage: number; viewer?: Role; version?: number }) {
  const stages = REVIEW_STAGES
  const position = stages.findIndex(s => s.stage === stage)
  return (
    <div className="stepper" aria-label="Pipeline stages">
      {stages.map((s, index) => (
        <div key={s.stage} className={`step ${index < position ? 'done' : s.stage === stage ? 'current' : ''}`}>
          <span className="n">{index < position ? '✓' : s.num}</span>
          <span className="lbl">{s.label}</span>
          <span className="who">{s.owner === 'sme' ? 'expert' : s.owner === 'agent' ? 'agent' : s.owner === 'engineer' ? (viewer === 'engineer' ? 'dev' : 'engineer') : ''}</span>
        </div>
      ))}
    </div>
  )
}
